var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.approved)?_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_vm._l((_vm.description),function(line){return _c('p',{key:line},[_vm._v("\n                "+_vm._s(line)+"\n            ")])}),_vm._v(" "),_c('p',[_vm._v("— Constant Cookbook")])],2)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }